import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { duplicateTask } from "~/store/actions/actions.tasks.jsx";
import { getTaskById } from "~/store/selectors/selector.tasks.jsx";
import { DuplicateObjectDialog } from "../DuplicateObjectDialog/DuplicateObjectDialog.jsx";

const TaskDuplicateDialog = ({ open, taskId, projectId, onCancel, onSuccess, onSubmit }) => {
  const dispatch = useDispatch();
  const task = useSelector((state) => getTaskById(state, taskId));

  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleDuplicate = useCallback(
    ({ name }) => {
      if (typeof onSubmit === "function") {
        onSubmit();
      }
      dispatch(
        duplicateTask(projectId, taskId, {
          new_name: name,
          project_id: projectId,
          task_id: taskId,
        })
      ).then((action) => {
        const { response = {} } = action;
        const { result = {} } = response;

        if (typeof onSuccess === "function") {
          onSuccess();
        }

        const { single = 0 } = result;

        if (single > 0) {
          navigate(`/projects/${projectId}/tasks/${single}`);
        }
      });
    },
    [onSubmit, dispatch, projectId, taskId, onSuccess, navigate]
  );

  return (
    <DuplicateObjectDialog
      open={open}
      name={task.get("name")}
      title={t("Duplicate Task")}
      labelText={t("Task name")}
      explainerText={t("All task properties, including subtasks will be copied to the new task.")}
      onSubmit={handleDuplicate}
      onCancel={onCancel}
    />
  );
};

TaskDuplicateDialog.propTypes = {
  open: PropTypes.bool,
  taskId: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
  onSubmit: PropTypes.func,
};

TaskDuplicateDialog.defaultProps = {
  open: false,
};

export default TaskDuplicateDialog;
